import { render, staticRenderFns } from "./ShippingAddressesForm.vue?vue&type=template&id=978d61fe&lang=pug"
import script from "./ShippingAddressesForm.vue?vue&type=script&lang=js"
export * from "./ShippingAddressesForm.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddressesForm.vue?vue&type=style&index=0&id=978d61fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports